import actions from "./actions"

const initialState = {
    statistics: null,
    prevStatistics: null,
    fuelReportByVehicle: [],
    fuelReportByDriver: [],
};

export default function statisticsReducers(state = initialState, action: {payload: any, type: string}): any {
    switch (action.type){
        case actions.SET_DAILY_STATISTICS:
            return {...state, statistics: action.payload};
        case actions.SET_PREV_STATISTICS:
            return {...state, prevStatistics: action.payload};
        case actions.SET_FUEL_REPORT_BY_VEHICLE:
            return {...state, fuelReportByVehicle: action.payload};
        case actions.SET_FUEL_REPORT_BY_DRIVER:
            return {...state, fuelReportByDriver: action.payload};
        default:
            return state
    }
}